var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",on:{"click":_vm.handleBack}},[(_vm.backHome)?[_c('img',{attrs:{"src":require("@/render/assets/images/icon_home.png")}})]:[_c('img',{attrs:{"src":require("@/render/assets/images/icon_back.png")}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }